import { differenceInMilliseconds, endOfDay, parseISO } from "date-fns";
import { useEffect, useState } from "react";

export const useContestAvailability = (validFrom?: string, validTo?: string) => {
   const [now, setNow] = useState(Date.now);
   const startsAt = validFrom ? parseISO(validFrom).getTime() : -Infinity;
   const endDate = validTo ? parseISO(validTo) : undefined;
   // A date without a time includes the whole final day. Timestamps keep their exact deadline.
   const endsAt = endDate ? (validTo?.length === 10 ? endOfDay(endDate) : endDate).getTime() : Infinity;
   const nextChange = now < startsAt ? startsAt : endsAt + 1;

   useEffect(() => {
      if (!Number.isFinite(nextChange) || nextChange <= now) {
         return;
      }
      const timer = setTimeout(() => setNow(Date.now()), Math.min(differenceInMilliseconds(nextChange, Date.now()), 2147483647));
      return () => clearTimeout(timer);
   }, [nextChange, now]);

   const canSubmit = () => {
      const submittedAt = Date.now();
      setNow(submittedAt);
      return submittedAt >= startsAt && submittedAt <= endsAt;
   };

   return { isNotAvailableYet: now < startsAt, isExpired: now > endsAt, canSubmit };
};
